'use client'
import { BlocksRenderer, BlocksContent } from '@strapi/blocks-react-renderer'

export const StrapiBlock = ({ content }: { content?: BlocksContent }) => {
  if (!content) return null
  return (
    <BlocksRenderer
      blocks={{
        list: ({ format, children }) =>
          format === 'ordered' ? <ol>{children}</ol> : <ul className="list-disc pl-3 lg:pl-10">{children}</ul>,
      }}
      content={content}
    />
  )
}
